import {noPrepOpt, PrepOption} from "../PrepMenuOptions";
import React from "react";
import {Alert} from "@mui/material";
import {useFixer} from "./Fixer";

export function PrepNoOptions(props: {
    value: PrepOption;
    onChange(value: Partial<PrepOption>): void;
}) {

    const fix = useFixer({
        value: props.value,
        autoFix: () => noPrepOpt,
        onChange: props.onChange,
    })

    if(fix) {
        return (
            <Alert severity="warning" style={{marginTop: 8, marginBottom: 8}}>
                Some background properties need to update. Please save product when you're done.
            </Alert>
        )
    }

    return null;
}